exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-15fbda56]{margin:20px;padding:15px;border:1px solid #f0ad4e;background-color:#fcf8e3;color:#8a6d3b;border-radius:5px}.text-bold[data-v-15fbda56]{font-weight:700}", ""]);

// exports
